import React, { useState, useEffect } from "react";
import "./UserDetailRedesign.css";
import { useLocation, useNavigate } from "react-router-dom";
import Sidemenu from '../base/sidemenu';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList, ResponsiveContainer, AreaChart, Area, ReferenceArea, ComposedChart, Line} from "recharts"
import moment from "moment";
import axios from "axios";
import { useParams } from "react-router-dom";
import { deleteUser, getSwitchInfo, getEmergencyLogs, deleteEmergencyLog, getPowerTimeline } from "../../services/userApiServicer";

const parseJwt = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
}; 
const ONE_HOUR = 60 * 60 * 1000;
const today = new Date();
const sevenDaysAgo = new Date();
sevenDaysAgo.setDate(today.getDate() - 6);

export default function UserDetailRedesign() {
  const navigate = useNavigate();
    const location = useLocation();
    const [tab, setTab] = useState("info");
    useEffect(() => {
    if (location.state?.defaultTab) {
        setTab(location.state.defaultTab);
    }
    }, [location.state]);
  const token = localStorage.getItem("token");
  const user = token ? parseJwt(token) : null;
  const [userData, setUserData] = useState({});
  const [dailySwitchCount, setDailySwitchCount] = useState([]);
  const [dailySwitchonline, setDailySwitchonline] = useState([]);
  const [dailySwitchTimeline, setDailySwitchTimeline] = useState([]);
  const [powerData, setPowerData] = useState([]);
  const [emergencyLogs, setEmergencyLogs] = useState([]);
  const { id } = useParams();
  const isSuperAdmin = user?.auth === 1;

  const fetchUserList = async () => {
    try {
      console.log('userData.id : ', user.id)
      console.log("token : ", token)
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/user/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },

      });
      console.log("사용자 목록 불러오기 성공:", response.data.user);
      setUserData(response.data.user);
    } catch (error) {
      console.error("사용자 목록 불러오기 실패:", error);
    }
  };
  const handleTabChange = (newTab) => {
    setTab(newTab);
    localStorage.setItem("selectedTab", newTab);
  };
  const formatDateToMMDD = (isoDate) => {
    const date = new Date(isoDate);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${month}/${day}`;
  };
  const formatMinutesToHours = (minutes) => {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;

    if (h > 0) {
      return `${h}시간 ${m}분`;
    } else {
      return `${m}분`;
    }
  };
  const getRoundedMax = (data, key, unit = 10) => {
    const maxValue = Math.max(...data.map((item) => item[key] || 0));
    return Math.ceil(maxValue / unit) * unit + 10;
  };
  const SwitchInfo = async () => {
    try {

      const data = await getSwitchInfo(userData.id, token);
      if (data.success === false) {
        alert(data.message);
        return;
      }
      console.log("사용자 스위치 정보", userData.id)
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);

      const formattedSwitchCount = data.switch_count.map(item => ({
        ...item,
        event_date: formatDateToMMDD(item.event_date),
      }));

      const formattedSwitchTimeline = data.switch_start_end.map(item => ({
        ...item,
        event_date: formatDateToMMDD(item.event_date),
      }));
      const formattedSwitchOnline = data.switch_on.map(item => ({
        ...item,
        event_date: formatDateToMMDD(item.event_date),
      }));

      setDailySwitchCount(formattedSwitchCount);
      setDailySwitchonline(formattedSwitchOnline);
      setDailySwitchTimeline(formattedSwitchTimeline);
      console.log("스위치 정보 ", data)

    } catch (error) {
      console.error("스위치 전력 정보", error);
    }
  };

  useEffect(() => {
    fetchUserList();
  }, []);

  useEffect(() => {
    if (userData?.id) {
      SwitchInfo();
      fetchEmergencyLogs();
      fetchPowerData();
    }
  }, [userData]);

  useEffect(() => {
  // 1시간(60분 * 60초 * 1000밀리초)
  const intervalId = setInterval(() => {
    if (userData?.id) {
      fetchPowerData();
      SwitchInfo();
      fetchEmergencyLogs();
    }
  }, 60 * 60 * 1000);

  // 컴포넌트 언마운트 시 interval 정리
  return () => clearInterval(intervalId);
}, [userData]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleDelete = async () => {
    console.log("delete", userData.id);
    if (!window.confirm(`정말 ${userData.name}님을 삭제하시겠습니까?`)) return;

    try {
      const result = await deleteUser(userData.id, token);
      if (result.success === false) {
        alert(result.message);
        return;
      }
      alert(result.message);
      navigate("/user");
    } catch (error) {
      console.error("삭제 실패:", error);
      alert("사용자 삭제에 실패했습니다.");
    }
  };


const fetchEmergencyLogs = async () => {
  try {
    const data = await getEmergencyLogs(userData.id, token);
    setEmergencyLogs(data || []);
    console.log("응급상황 데이터:", data);
  } catch (error) {
    alert("응급상황 기록을 불러오지 못했습니다.");
  }
};

const handleDeleteLog = async (alert_id) => {
  if (!window.confirm("정말 이 응급상황 기록을 삭제하시겠습니까?")) return;

  try {
    const result = await deleteEmergencyLog(alert_id, token);
    if (result.success === false) {
      alert(result.message);
      return;
    }
    alert("삭제가 완료되었습니다.");
    fetchEmergencyLogs(); // 삭제 후 새로고침
  } catch (error) {
    alert("삭제 중 오류가 발생했습니다.");
  }
};

/* 전력 */
const fetchPowerData = async () => {
  try {
    const raw = await getPowerTimeline(userData.id, token);
    if (!Array.isArray(raw) || raw.length === 0) {

	const emptyDayData = [];
	const baseDate = moment().startOf('day');

	for (let minute = 0; minute < 24 * 60; minute++) {
  		const currentTime = baseDate.clone().add(minute, 'minutes');

    		emptyDayData.push({
      			time: currentTime.format("HH:mm"),
      			watt: null,
      			state: "unknown"
    		});
  	}

  	setPowerData(emptyDayData);

	return;
    }
    // 시간별로 정렬
    const sorted = [...raw].sort((a, b) => 
      moment(a.create_date).diff(moment(b.create_date))
    );

    // 00:00 ~ 23:59까지 1분 단위로 전체 타임라인 생성
    const fullDayData = [];
    const baseDate = moment(sorted[0].create_date).startOf('day');
    const firstDataTime = moment(sorted[0].create_date);
    const now = moment(); // 현재 시간
    const lastDataTime = moment(sorted[sorted.length - 1].create_date);
    
    for (let minute = 0; minute < 24 * 60; minute++) {
      const currentTime = baseDate.clone().add(minute, 'minutes');
      const timeStr = currentTime.format("HH:mm");
      
      // 첫 데이터 시간 이전이면 꺼진 상태(0W)로 표시
      if (currentTime.isBefore(firstDataTime)) {
        fullDayData.push({
          time: timeStr,
          watt: 0,
          state: "off"
        });
        continue;
      }
      
      // 마지막 데이터 이후이고 현재 시간을 넘어가면 null로 표시 (색 칠하지 않음)
      if (currentTime.isAfter(lastDataTime) && currentTime.isAfter(now)) {
        fullDayData.push({
          time: timeStr,
          watt: null,
          state: "unknown"
        });
        continue;
      }
      
      // 해당 시간의 전력 상태 찾기 (가장 최근의 상태를 찾음)
      let watt = null;
      let state = "off";
      
      for (let i = sorted.length - 1; i >= 0; i--) {
        const dataTime = moment(sorted[i].create_date);
        if (dataTime.isSameOrBefore(currentTime)) {
          watt = sorted[i].watt;
          state = watt > 0 ? "on" : "off";
          break;
        }
      }
      
      fullDayData.push({
        time: timeStr,
        watt: watt,
        state: state
      });
    }
    console.log(
  '[POWER DEBUG]',
  {
    rawLength: raw.length,
    sortedFirst: sorted[0],
    sortedLast: sorted[sorted.length - 1],
    fullLength: fullDayData.length,
    nonZero: fullDayData
      .filter(x => Number(x.watt) > 0)
      .slice(0, 20)
  }
);
    setPowerData(fullDayData);
  } catch (err) {
    console.error("전력 데이터 처리 실패", err);
  }
};

return (
  <div className="flex user-detail-redesign-layout">
    <Sidemenu />

    <main className="user-detail-redesign-content">
      <div className="ud-page">

        <div className="ud-top">
          <button className="ud-back" onClick={handleGoBack}>
            ← 사용자 목록
          </button>
        </div>

        <div className="ud-tabs" role="tablist">
          {[
            ["info", "사용자"],
            ["power", "스위치"],
            ["energy", "전력"],
            ["sensor", "감지기"],
            ["alert", "응급상황"],
          ].map(([key, label]) => (
            <button
              key={key}
              role="tab"
              aria-selected={tab === key}
              className={tab === key ? "ud-active" : ""}
              onClick={() => handleTabChange(key)}
            >
              {label}
            </button>
          ))}
        </div>
          {/* 사용자 상세정보 */}
          {tab === "info" && (
            <>
              <h2 className="ud-title">
                {userData.name} 님의 상세정보
              </h2>
              <div className="ud-accent" />

              <div className="ud-user-sections">
                <div className="ud-user-layout">

                  {/* 기본정보 */}
                  <section className="ud-section">
                    <h3>기본정보</h3>

                    <div className="ud-info">
                      {[
                        ["나이", userData.age != null ? `만 ${userData.age}세` : "-"],
                        ["생년월일", userData.birth || "-"],
                        ["성별", userData.sex || "-"],
                        ["전화번호", userData.phone || "-"],
                        [
                          "주소",
                          [userData.address, userData.detail_address]
                            .filter(Boolean)
                            .join(" ") || "-"
                        ],
                        ["지병", userData.pec || "-"],
                      ].map(([label, value]) => (
                        <div className="ud-info-row" key={label}>
                          <b>◉ &nbsp;{label}</b>
                          <span>{value}</span>
                        </div>
                      ))}
                    </div>
                  </section>

                  <div className="ud-user-side">

                    {/* 보호자 및 담당 관리 */}
                    <section className="ud-section">
                      <h3>보호자 및 담당 관리</h3>

                      <div className="ud-info">
                        <div className="ud-info-row">
                          <b>◉ &nbsp;담당 관리</b>
                          <span>{userData.department_name || "-"}</span>
                        </div>

                        <div className="ud-info-row">
                          <b>◉ &nbsp;가족정보</b>
                          <span>
                            {Array.isArray(userData.family) &&
                            userData.family.length > 0
                              ? userData.family.map((member, index) => (
                                  <span key={index} className="family">
                                    {member.family_info?.trim() || "-"}
                                  </span>
                                ))
                              : "등록된 가족정보가 없습니다."}
                          </span>
                        </div>
                      </div>
                    </section>

                    {/* 위험군 및 응급상황 */}
                    <section className="ud-section">
                      <h3>위험군 및 응급상황</h3>

                      <div className="ud-info">
                        <div className="ud-info-row">
                          <b>◉ &nbsp;위험군 등급</b>
                          <span>{userData.sev_name || "-"}</span>
                        </div>

                        <div className="ud-info-row">
                          <b>◉ &nbsp;응급상황 횟수</b>
                          <span>
                            {userData.alert_count != null
                              ? `${userData.alert_count}회`
                              : "-"}
                          </span>
                        </div>
                      </div>
                    </section>

                  </div>
                </div>
              </div>

              {/* 기존 관리 기능 유지 */}
              <div className="ud-actions">
                {isSuperAdmin && (
                  <button
                    className="ud-action-delete"
                    onClick={handleDelete}
                  >
                    삭제
                  </button>
                )}

                {isSuperAdmin && (
                  <button
                    className="ud-action-edit"
                    onClick={() =>
                      navigate("/user/edit", { state: { userData } })
                    }
                  >
                    수정
                  </button>
                )}

                <button
                  className="ud-action-list"
                  onClick={() => navigate("/user")}
                >
                  확인 · 목록으로
                </button>
              </div>
            </>
          )}
          {/* 사용자 스위치 */}
          {tab === "power" && (
            <>
              <h2 className="ud-title">
                {userData.name} 님의 스위치 정보
              </h2>
              <div className="ud-accent" />

              <div className="ud-two">
                {/* 일별 스위치 사용 횟수 */}
                <section className="ud-card">
                  <div className="ud-chart">
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart
                        data={dailySwitchCount}
                        margin={{ top: 30, right: 15, left: 0, bottom: 10 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis
                          dataKey="event_date"
                          tick={{ fontSize: 13 }}
                        />
                        <YAxis
                          width={55}
                          allowDecimals={false}
                          domain={[0, "dataMax + 2"]}
                          tick={{ fontSize: 13 }}
                        />
                        <Tooltip
                          formatter={(value) => [`${value}회`, "스위치 사용 횟수"]}
                        />
                        <Bar
                          dataKey="event_count"
                          fill="#509af1"
                          barSize={40}
                          radius={[4, 4, 0, 0]}
                        >
                          <LabelList
                            dataKey="event_count"
                            position="top"
                            formatter={(value) => `${value}회`}
                          />
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                  <p>일별 스위치 사용 횟수</p>
                </section>

                {/* 일별 스위치 ON 지속 시간 */}
                <section className="ud-card">
                  <div className="ud-chart">
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart
                        data={dailySwitchonline}
                        margin={{ top: 30, right: 15, left: 0, bottom: 10 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis
                          dataKey="event_date"
                          tick={{ fontSize: 13 }}
                        />
                        <YAxis
                          width={55}
                          allowDecimals={false}
                          domain={[
                            0,
                            getRoundedMax(dailySwitchonline, "on_minutes", 10)
                          ]}
                          tick={{ fontSize: 13 }}
                        />
                        <Tooltip
                          formatter={(value) => [
                            formatMinutesToHours(value),
                            "스위치 ON 지속 시간"
                          ]}
                        />
                        <Bar
                          dataKey="on_minutes"
                          fill="#ff914d"
                          barSize={40}
                          radius={[4, 4, 0, 0]}
                        >
                          <LabelList
                            dataKey="on_minutes"
                            position="top"
                            formatter={formatMinutesToHours}
                          />
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                  <p>일별 스위치 ON 지속 시간</p>
                </section>
              </div>

              {/* 최근 7일 사용 시간 */}
              <div className="ud-table-scroll">
                <table className="ud-table">
                  <thead>
                    <tr>
                      <th>구분</th>
                      {dailySwitchTimeline.map((item, index) => (
                        <th key={`${item.event_date}-${index}`}>
                          {item.event_date}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>첫 사용 시간</td>
                      {dailySwitchTimeline.map((item, index) => (
                        <td key={index}>{item.first_on_time || "-"}</td>
                      ))}
                    </tr>
                    <tr>
                      <td>마지막 사용 시간</td>
                      {dailySwitchTimeline.map((item, index) => (
                        <td key={index}>{item.last_on_time || "-"}</td>
                      ))}
                    </tr>
                    <tr>
                      <td>수면 추정 시간</td>
                      {dailySwitchTimeline.map((item, index) => (
                        <td key={index}>{item.sleep_start_end_time || "-"}</td>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="ud-actions">
                <button className="ud-action-list" onClick={handleGoBack}>
                  확인 · 목록으로
                </button>
              </div>
            </>
          )}
          {/* 사용자 전력량 */}
         {tab === "energy" && (
  <div className="user_power ud-energy">
    <h2 className="ud-title">
      {userData.name} 님의 전력정보
    </h2>
    <div className="ud-accent" />
    <div className="power_charts_wrp">
      <div className="chart01">
        <div className="chartbox">
            <ResponsiveContainer width="100%" height="100%">
                <ComposedChart
                    data={powerData}
                    margin={{ top: 40, right: 20, left: 20, bottom: 20 }}
                >
                <XAxis 
                dataKey="time"
                interval={119}
                tick={{ fontSize: 12 }}
                />
                <YAxis width={60} domain={[0, 10]} />
                <Tooltip
                formatter={(v) => (v !== null ? `${v}W` : "데이터 없음")}
                labelFormatter={(label) => `시간: ${label}`}
                />

                <Area
                type="monotone"
                dataKey="watt"
                stroke="none"
                fill="#ff5722"
                fillOpacity={0.3}
                tooltipType="none"
                dot={false}
                isAnimationActive={false}
                label={({ x, y, index }) => {
                    // 마지막 watt 값이 있는 지점 찾기
                    const lastWattIndex = powerData.map((d, i) => d.watt !== null ? i : -1)
                    .filter(i => i !== -1)
                    .pop();
                    
                    // 마지막 watt 지점이고, 그 이후에 null이 있으면 현재시간 표시
                    if (index === lastWattIndex && powerData.slice(lastWattIndex + 1).some(d => d.watt === null)) {
                    return (
                        <text x={x} y={y - 10} fill="#ff5722" fontSize={12} fontWeight="bold" textAnchor="middle">
                        현재 시간: {moment().format("HH:mm")}
                        </text>
                    );
                    }
                    return null;
                    }}
                    />

                    {/* 선 그래프 */}
                    <Line
                    type="monotone"
                    dataKey="watt"
                    stroke="#ff5722"
                    strokeWidth={2}
                    dot={false}
                    isAnimationActive={false}
                    />

                </ComposedChart>
            </ResponsiveContainer>



                  </div>
                    <p className="chartit">켜짐/꺼짐 구간 전력 변화</p>
                </div>
              </div>
              <div className="ud-actions">
                <button className="ud-action-list" onClick={handleGoBack}>
                  확인 · 목록으로
                </button>
              </div>
              </div>
            )}
          {/* 사용자 감지기 - 연동 준비 중 */}
          {tab === "sensor" && (
            <div className="ud-sensor">
              <h2 className="ud-title">
                {userData.name} 님의 감지기 정보
              </h2>
              <div className="ud-accent" />

              <div className="ud-empty">
                <h3>감지기 연동 준비 중</h3>
                <p>
                  현재 감지기 데이터 연동을 준비하고 있습니다.
                  연동이 완료되면 감지 이력과 활동 현황을 확인할 수 있습니다.
                </p>
              </div>

              <div className="ud-actions">
                <button onClick={handleGoBack}>확인 · 목록으로</button>
              </div>
            </div>
          )}
          {/* 사용자 응급상황기록 */}
          {tab === "alert" && (
            <div className="user_detail">
              <h2 className="ud-title">
                {userData.name} 님의 응급정보
              </h2>
              <div className="ud-accent" />
              <div className="detail_box">
                <ul>
                  <li className="noflex"><p className="tit">응급상황 기록</p></li>
                </ul>
                {emergencyLogs.length > 0 ? (
                  emergencyLogs.map((log, index) => (
                    <div key={index} className="emergency_log">
                      <p className="emergency_title_line">{moment(log.create_date).format("YYYY-MM-DD")} 발생한 응급상황 </p>
                      <p className="write_info">작성자 : {log.admin_name}<span>작성시간 : {log.write_create_date}</span></p>
                      <p className="emergency_log_tit">증상 및 상황조치</p>                      
                      <p className="emergency_log_txt">{log.content}</p>                      
                      <div className="btn-group">
                        <button className="btncolor02" onClick={() => handleDeleteLog(log.alert_id)}>삭제</button>
                        <button className="btncolor04" onClick={() => navigate("/user/alert/edit", { state: { log, adminId: user?.id } })}>수정</button>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>등록된 응급상황 기록이 없습니다.</p>
                )}
              </div>
              <div className="btn-group">
                <button className="btncolor02" onClick={() => navigate("/user/alert/new", { state: { user_id: userData.id, admin_id: user?.id } })
                } >등록</button>
                <button className="btncolor01" onClick={handleGoBack}>확인</button>
              </div>
            </div>
          )}

        </div>
      
      </main>
    </div>
  );
}

